import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const CampaignBudgetAction = ({ c }) => {
  const [open, setOpen] = useState(false);
  const [to, setTo] = useState(c.daily_budget);
  const [busy, setBusy] = useState(false);
  const submit = async () => {
    setBusy(true);
    try {
      const d = await api.post("/proposals/campaign-budget", { campaign_id: c.id, to: Number(to) });
      toast.success(d.preflight?.length ? `Proposal created. Before it can run: ${d.preflight[0]}` : "Budget proposal created. Approve it in Approvals.");
      setOpen(false);
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  if (!open) return <button data-testid={`campaign-budget-change-${c.id}`} onClick={() => setOpen(true)} className="text-[11px] text-sky-400 hover:underline">Change daily budget</button>;
  return (
    <span className="flex items-center gap-2">
      <input data-testid={`campaign-budget-input-${c.id}`} type="number" min="1" step="1" value={to} onChange={(e) => setTo(e.target.value)} className="cc-input w-24 px-2 py-1 font-mono text-xs" />
      <button data-testid={`campaign-budget-submit-${c.id}`} disabled={busy || Number(to) < 1} onClick={submit} className="cc-btn cc-btn-primary px-2 py-1 text-[11px]">Create proposal</button>
      <button data-testid={`campaign-budget-cancel-${c.id}`} onClick={() => setOpen(false)} className="text-[11px] text-slate-500 hover:underline">Cancel</button>
    </span>
  );
};
